/**
 * ResponsavelVisualizador
 * @author Simpli CLI generator
 */
import {$, Helper, Request, Resource} from 'simpli-web-sdk'
import {ResponseExclude, ResponseSerialize} from 'simpli-web-sdk'
import {Responsavel} from '@/model/resource/Responsavel'
import {ResponsavelVisualizadorCollection} from '@/model/collection/ResponsavelVisualizadorCollection'

/* TODO: review generated class */
export class ResponsavelVisualizador extends Resource {
  idVisualizadorPk: number = 0

  @ResponseSerialize(Responsavel)
  responsavel: Responsavel | null = null

  nome: string | null = null
  email: string | null = null
  dataCriacao: string | null = null
  ativo: boolean | null = null

  @ResponseExclude()
  senha: string | null = null

  get $id() {
    return this.idVisualizadorPk
  }
  set $id(val) {
    this.idVisualizadorPk = val
  }
  get $tag() {
    return String(this.nome)
  }

  get idResponsavelFk() {
    if (!this.responsavel) return 0
    return this.responsavel.$id
  }
  set idResponsavelFk(val) {
    if (!this.responsavel) this.responsavel = new Responsavel()
    this.responsavel.$id = val
  }

  /**
   * Gets a instance of a given ID of ResponsavelVisualizador
   */
  async getResponsavelVisualizador(id: number) {
    return await Request.get(`/admin/responsavel-visualizador/${id}`)
      .name('getResponsavelVisualizador')
      .as(this)
      .getData()
  }

  /**
   * Deletes a instance of a given ID of ResponsavelVisualizador
   */
  async removeResponsavelVisualizador() {
    return await Request.delete(`/admin/responsavel-visualizador/${this.$id}`)
      .name('removeResponsavelVisualizador')
      .asNumber()
      .getData()
  }

  /**
   * Lists the instances of ResponsavelVisualizador
   */
  static async listResponsavelVisualizador(params: any) {
    return await Request.get(`/admin/responsavel-visualizador`, {params})
      .name('listResponsavelVisualizador')
      .as(ResponsavelVisualizadorCollection)
      .getData()
  }

  /**
   * Persists a new instance of ResponsavelVisualizador. Use ID = 0 to create a new one,
   * or ID > 0 to update a current one
   */
  async persistResponsavelVisualizador() {
    return await Request.post(`/admin/responsavel-visualizador`, this)
      .name('persistResponsavelVisualizador')
      .asNumber()
      .getData()
  }

  /**
   * Lists the instances of ResponsavelVisualizador to use it in a CSV file
   */
  static async listCsvResponsavelVisualizador(params: any) {
    return await Request.get(`/admin/responsavel-visualizador/csv`, {params})
      .name('listCsvResponsavelVisualizador')
      .as(ResponsavelVisualizadorCollection)
      .getData()
  }
}
